<template>
  <div
    class="custom-control custom-radio align-item-center d-flex"
    :class="[inlineClass, { disabled: disabled }]"
  >
    <input
      :id="cbId"
      label="title"
      :name="name"
      class="custom-control-input"
      type="radio"
      :disabled="disabled"
      :value="value"      
      v-model="model"
      :checked="checked"
      @input="(event) => $emit('update:checked', event.target.value)"
    />
    <label :for="cbId" class="custom-control-label">
      <slot>{{label}}</slot>
    </label>
  </div>
</template>
<script>
import { randomString } from "./stringUtils";
export default {
  name: "base-radio",
  props: {
    name: {
        type: String,
        description: 'Input name (used for validation)',
        default: ''
      },
    disabled: {
      type: Boolean,
      description: "Whether radio is disabled",
    },
    value: {
      type: [String, Boolean],
      description: "Radio value",
    },
    inline: {
      type: Boolean,
      description: "Whether radio is inline",
    },
     label: {
        type: String,
        description: ""
      },
  },
  data() {
    return {
      cbId: "",
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      }
      return "";
    },
  },
  mounted() {
    this.cbId = randomString();
    },
};
</script>
